let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bfEtT")).then(() => parcelRequire('hk6N7'));